<template>
    <div>
        {{historyState}}
        <template v-if="historyState.data">
            <table>
                <tr>
                    <th>Amount</th>
                    <th>Date</th>
                </tr>
                <tr v-for="item in historyState.data">
                    <td>{{item.amount}}</td>
                    <td>{{item.date}}</td>
                    <td>{{item}}</td>
                </tr>
            </table>
        </template>
    </div>
</template>
<script>
import ReactivePromiseStatus from "reactive-promise-status/dist/reactive-promise-status";
import {Api} from "@/api";

export default {
    name: 'CreditsHistory',
    data() {
        return {
            historyState:new ReactivePromiseStatus(),
        }
    },
    async mounted() {
        this.historyState.promise=Api.credit.history();
    }
}
</script>
